import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  try {
    const t = localStorage.getItem("fx_token");
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
  } catch (e) { /* private mode: rely on session cookie */ }
  return cfg;
});

export default api;

export function formatErr(detail) {
  if (detail == null) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(", ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
